import React from 'react';

import cx from 'classnames';

import styles from './Services.m.sass';
import content from '../content/Content.m.sass';

import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';

import LocationDispatchingSink from '../../containers/locationDispatchingSink/LocationDispatchingSink';
import OnlineSupport from '../onlineSupport/OnlineSupport';
import Menu from '../menu/Menu';
import Events from '../events/Event';
import ProductList from '../product/ProductList';
import Loader from '../loader/Loader';
import Meta from '../meta/Meta';


@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: true})
export default class Services extends React.PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.currentTaxon !== prevState.currentTaxon
      || nextProps.menuTree !== prevState.menuTree
      || nextProps.products !== prevState.products
      || nextProps.showcase !== prevState.showcase
    ) {
      if (!nextProps.currentTaxon || !nextProps.menuTree || !nextProps.products || nextProps.showcase === undefined || nextProps.showcase === null) {
        return {loading: true};
      } else {
        return {
          currentTaxon: nextProps.currentTaxon,
          menuTree: nextProps.menuTree,
          products: nextProps.products,
          showcase: nextProps.showcase,
          loading: false
        };
      }
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      currentTaxon: props.currentTaxon,
      menuTree: props.menuTree,
      products: props.products,
      loading: !props.currentTaxon || !props.menuTree || !props.products || !props.showcase
    };
  }

  render() {
    const {collapsed} = this.props;
    const {loading, currentTaxon, menuTree, products, showcase} = this.state;

    if (!currentTaxon || !menuTree || !products) {
      return <Loader section/>
    }

    const taxonMeta = (currentTaxon && currentTaxon.metatag) || {};

    return (
        <div className="container">
          {!!currentTaxon && (
            <LocationDispatchingSink
              menuTaxon={currentTaxon.slug}
              breadcrumbs={[currentTaxon]}
            />
          )}

          {!!currentTaxon && (
            <Meta
              title={taxonMeta.pageTitle}
              fallbackTitle={currentTaxon.name}
              description={taxonMeta.description}
              keywords={taxonMeta.keywords}
              image={!!currentTaxon.images.length && currentTaxon.images[0].path}
            />
          )}

          {loading && <Loader overlay/>}

          <div className={cx(styles.services, loading && styles.services__loading)}>
            <div className={content.content_inner}>
              <div className="row">
                {!collapsed && (
                  <div className={content.content_sidebar}>
                    <Menu items={menuTree}/>
                    <OnlineSupport/>
                  </div>
                )}

                <div className={content.content_full}>
                  <h2 className={content.content_header}>
                    {currentTaxon.headTitle || currentTaxon.name}
                  </h2>

                  {showcase && (
                    <Events
                      event={showcase.event}
                      eventOccurrences={showcase.eventOccurrences}
                      products={showcase.products}
                    />
                  )}

                  <div className={content.content_products}>
                    <ProductList products={products}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/services/Services.js